import React from "react";

const DeliveryTime = ({ deliveryTime, onChange }) => {
  const { fromDate, toDate } = deliveryTime;

  const formatDisplay = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    return dt.toLocaleDateString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" });
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <div className="relative">
          <label className="absolute -top-2 left-3 text-[10px] font-medium text-primaryColor bg-white px-1 z-10">
            From*
          </label>
          <div className="relative">
            <input
              type="date"
              value={fromDate}
              min={today}
              onChange={(e) => onChange("fromDate", e.target.value)}
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg text-sm outline-none focus:border-primaryColor focus:ring-1 focus:ring-primaryColor/20 transition-all appearance-none bg-white"
            />
            {/* <svg
              className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"
              fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg> */}
          </div>
        </div>

        <div className="relative">
          <label className="absolute -top-2 left-3 text-[10px] font-medium text-primaryColor bg-white px-1 z-10">
            To*
          </label>
          <div className="relative">
            <input
              type="date"
              value={toDate}
              min={fromDate || today}
              onChange={(e) => onChange("toDate", e.target.value)}
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg text-sm outline-none focus:border-primaryColor focus:ring-1 focus:ring-primaryColor/20 transition-all appearance-none bg-white"
            />
            {/* <svg
              className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"
              fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg> */}
          </div>
        </div>
      </div>

      {/* Display row */}
      {fromDate && toDate && (
        <div className="flex items-center justify-between bg-primaryColor/5 border border-primaryColor/15 rounded-lg px-4 py-2.5">
          <span className="text-xs text-gray-500">Expected Delivery Date —</span>
          <span className="text-sm font-bold text-primaryColor">
            {formatDisplay(fromDate)} – {formatDisplay(toDate)}
          </span>
        </div>
      )}

      {/* Validation */}
      {fromDate && toDate && new Date(toDate) <= new Date(fromDate) && (
        <p className="text-xs text-red-500 flex items-center gap-1">
          <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          End date must be after start date
        </p>
      )}
    </div>
  );
};

export default DeliveryTime;